import { render, staticRenderFns } from "./MaterialsSummary.vue?vue&type=template&id=889ce572"
import script from "./MaterialsSummary.vue?vue&type=script&lang=js"
export * from "./MaterialsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports